"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _ActionButton = _interopRequireDefault(require("@eig-builder/core-ui/ActionButton"));

var _Typography = _interopRequireDefault(require("@eig-builder/core-ui/Typography"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  line-height: 21px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  vertical-align: middle;\n  align-items: center;\n\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TextIconWrapper = _styledComponents.default.span(_templateObject());

var ExpandIcon = (0, _styledComponents.default)(_Icon.default)(_templateObject2());

var ActionButton = function ActionButton(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      icon = _ref.icon,
      tooltip = _ref.tooltip,
      title = _ref.title,
      active = _ref.active,
      border = _ref.border,
      width = _ref.width,
      height = _ref.height,
      padding = _ref.padding,
      margin = _ref.margin,
      marginSides = _ref.marginSides,
      textVariant = _ref.textVariant,
      textStyling = _ref.textStyling,
      expandIcon = _ref.expandIcon,
      size = _ref.size,
      dataElementLocation = _ref.dataElementLocation,
      dataElementLabel = _ref.dataElementLabel,
      dataElementId = _ref.dataElementId;
  return _react.default.createElement(_ActionButton.default, _extends({
    className: className,
    onClick: onClick,
    disabled: disabled,
    active: active,
    border: border,
    width: width,
    height: height,
    margin: margin,
    padding: padding,
    title: tooltip || title,
    marginSides: marginSides,
    size: size
  }, (0, _taggingHelper.getDataProperty)({
    dataElementType: _taggingHelper.DataElementTypes.BUTTON,
    dataElementLocation: dataElementLocation,
    dataElementLabel: dataElementLabel,
    dataElementId: dataElementId
  })), icon && _react.default.createElement(_Icon.default, {
    icon: icon
  }), title && _react.default.createElement(_Typography.default, {
    variant: textVariant,
    style: textStyling
  }, _react.default.createElement(TextIconWrapper, null, _react.default.createElement(_moduleLocalization.default, {
    message: title,
    style: {
      fontWeight: "".concat(icon ? '300' : '600')
    }
  }), expandIcon && _react.default.createElement(ExpandIcon, {
    icon: "arrow_drop_down"
  }))));
};

ActionButton.propTypes = {
  onClick: _propTypes.default.func.isRequired,
  icon: _propTypes.default.string,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  tooltip: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  active: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  className: _propTypes.default.string,
  border: _propTypes.default.bool,
  height: _propTypes.default.string,
  width: _propTypes.default.string,
  padding: _propTypes.default.string,
  margin: _propTypes.default.string,
  marginSides: _propTypes.default.string,
  textVariant: _propTypes.default.string,
  textStyling: _propTypes.default.object,
  expandIcon: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['medium', 'large']),
  dataElementLocation: _propTypes.default.oneOf(_taggingHelper.DataElementLocationsArray).isRequired,
  dataElementLabel: _propTypes.default.string.isRequired,
  dataElementId: _propTypes.default.string.isRequired
};
ActionButton.defaultProps = {
  textVariant: 'label',
  size: 'medium'
};
var _default = ActionButton;
exports.default = _default;